import { render, staticRenderFns } from "./triangle.vue?vue&type=template&id=cde02418&"
import script from "./triangle.vue?vue&type=script&lang=js&"
export * from "./triangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports